export default [
    {
        name: "name",
        label: "Name",
        type: "string",
    },
    {
        name: "email",
        label: "Email",
        type: "string",
    },
    {
        name: "phone",
        label: "Phone",
        type: "string",
    },
    {
        name: "organizationName",
        label: "Organization",
        type: "string",
    },
    {
        name: "createdAt",
        label: "Joined At",
        type: "date",
    },
];
